import { Icon as c } from "./icon.js";
import { IconReact as t } from "./icon-react.js";
export {
  c as Icon,
  t as IconReact
};
